module.exports = __webpack_public_path__ + "static/img/step01.005b168.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/publicauth/img/step01.jpeg
// module id = 723
// module chunks = 1